/* Feature sections — triptych layout, one full-width section per feature. */

import React from 'react';
import { LpPhoneScreenshot } from './shared-sections.jsx';

const FEATURES_DATA = [
  {
    id: 'feed',
    num: '01',
    nameText: 'Feed',
    headline: <>See what's <em>on the shelf</em>, right now.</>,
    body: "Bottle, store, price, distance. Everything you need to decide if it's worth the drive. Spot one yourself? Post it in a few taps.",
    bullets: [
      ['Trending now', "See which bottles your city is finding most this week."],
      ['Verified sightings', "Multiple hunters confirm what they see, so a label isn’t a guess."],
      ['Tuned to you', "Built around the bottles, distilleries, and styles you actually drink."],
    ],
    Phone: () => <LpPhoneScreenshot src="/img/feed.png" alt="DoubleOak Feed — nearby shelf sightings ranked by distance" loading="lazy"/>,
  },
  {
    id: 'bounties',
    num: '02',
    nameText: 'Bounties',
    headline: <>Tell us what you're <em>hunting</em>. We'll watch the shelves.</>,
    body: "Name the bottles you actually want. We'll watch every shelf in your area and ping you the moment one surfaces.",
    bullets: [
      ['Set and forget', "We keep watching the shelves so you don't have to."],
    ],
    Phone: () => <LpPhoneScreenshot src="/img/bounties.png" alt="DoubleOak Bounties — standing alerts for bottles you're hunting" loading="lazy"/>,
  },
  {
    id: 'squads',
    num: '03',
    nameText: 'Squads',
    headline: <>Give your <em>crew</em> the head start.</>,
    body: "Sightings hit the squad before they hit the city. A full day's jump on the same allocation everyone else is hunting.",
    bullets: [
      ['Squad-first', 'Your crew sees the sighting before it lands on the public feed.'],
      ['Pooled bounties', 'Share a bounty across the squad so every hunter is watching for it.'],
      ['Get notified', 'Find out the moment a squadmate posts a sighting.'],
    ],
    Phone: () => <LpPhoneScreenshot src="/img/squads.png" alt="DoubleOak Squads — private group with shared sightings and bounties" loading="lazy"/>,
  },
  {
    id: 'map',
    num: '04',
    nameText: 'Hunt Map',
    headline: <>Know which stores are <em>actually</em> worth checking.</>,
    body: "Every liquor store in your city, ranked by sighting activity. The quiet shops that stock the good stuff stop being secrets.",
    bullets: [
      ['Activity heatmap', 'Stores light up by how much sighting activity they’re getting.'],
      ['Hidden gems', 'Spot the small shops other hunters keep returning to.'],
      ['Store profiles', 'Tap any store for its sighting history and what it tends to stock.'],
    ],
    Phone: () => <LpPhoneScreenshot src="/img/huntmap.png" alt="DoubleOak Hunt Map — stores ranked by sighting activity" loading="lazy"/>,
  },
];

export function FeatureSections() {
  return (
    <div className="fv fv--C">
      <div className="fv-C__intro">
        <span className="lp-eyebrow">How it works</span>
      </div>
      {FEATURES_DATA.map((f, i) => {
        const reversed = i % 2 === 1;
        return (
          <section
            key={f.id}
            id={f.id}
            className={'fv-C__row' + (reversed ? ' fv-C__row--rev' : '') + (i === 1 ? ' fv-C__row--alt' : '')}
          >
            <div className="lp-section fv-C__strip">
              <span className="fv-C__strip-num">{f.num}</span>
              <span className="fv-C__strip-rule"></span>
              <span className="fv-C__strip-name">{f.nameText}</span>
            </div>

            <div className="lp-section fv-C__body">
              <div className="fv-C__copy">
                <h2 className="fv-C__title">{f.headline}</h2>
                <p className="fv-C__lede">{f.body}</p>
                <ul className="fv-C__bullets">
                  {f.bullets.map(([b, s], j) => (
                    <li key={j}>
                      <span className="b">{b}</span>
                      <span className="s">{s}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="fv-C__art">
                <div className="fv-C__art-frame">
                  <div className="lp-phone">
                    <div className="lp-phone__notch"></div>
                    <div className="lp-phone__inner"><f.Phone/></div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        );
      })}
    </div>
  );
}
